import { ConsumptionState } from "../types/consumptionState";
import { aplClient } from "./apiClient";
import { PalletDetail } from "../types/palletDetail";
import { Activity } from "../types/activity";
import { MomentObject } from "../types/momentObject";
import { AxiosResponse } from "axios";
import { IssuingRequest } from "../types/issuingRequest";

const getConsumptionState = async (operationId: string, barcode: string): Promise<ConsumptionState> => {
    let response = aplClient().get(`consumptiondetails/verify/${operationId}/${barcode}`);
    return (await response).data;
};

const issuePalletRaw = async (
    sscc: string,
    lineId: number,
    workorderId: string,
    operationId: string,
    offline: boolean,
    consumptionStart: MomentObject | null | undefined,
    consumptionEnd: MomentObject | null | undefined,
    consumedPallets: string[]
): Promise<AxiosResponse<any, any>> => {
    let issuingRequest = {
        sscc: sscc,
        lineId: lineId,
        workorderId: workorderId,
        operationId: operationId,
        offline: offline,
        consumptionStart: consumptionStart,
        consumptionEnd: consumptionEnd,
        consumedPallets: consumedPallets?.map(x => x.toString())
    };
    return aplClient().post("consumptiondetails/issue", issuingRequest);
};

const getIssuingRequestOnline = (palletDetail: PalletDetail, activitiy: Activity, consumedPallets: string[]): IssuingRequest => {
    return {
        sscc: palletDetail.sscc,
        lineId: activitiy.lineId,
        workorderId: activitiy.workOrderId,
        operationId: activitiy.operationId,
        offline: false,
        consumptionStart: null,
        consumptionEnd: null,
        consumedPallets: consumedPallets
    };
};

const getIssuingRequestOffline = (
    palletDetail: PalletDetail,
    activitiy: Activity,
    consumedPallets: string[],
    dtstart: MomentObject,
    dtEnd: MomentObject
): IssuingRequest => {
    return {
        sscc: palletDetail.sscc,
        lineId: activitiy.lineId,
        workorderId: activitiy.workOrderId,
        operationId: activitiy.operationId,
        offline: true,
        consumptionStart: dtstart,
        consumptionEnd: dtEnd,
        consumedPallets: consumedPallets
    };
};

const issuePalletByIssuingRequest = (issuingRequest: IssuingRequest) => {
    return issuePalletRaw(
        issuingRequest.sscc,
        issuingRequest.lineId,
        issuingRequest.workorderId,
        issuingRequest.operationId,
        issuingRequest.offline,
        issuingRequest.consumptionStart,
        issuingRequest.consumptionEnd,
        issuingRequest.consumedPallets
    );
};

const deleteConsumption = async (consumptionId: string): Promise<AxiosResponse<any, any>> => {
    return aplClient().delete(`consumptiondetails/delete/${consumptionId}`);
};

const consumeConsumption = async (consumptionId: string, qtyConsumed: number): Promise<AxiosResponse<any, any>> => {
    return aplClient().put(`consumptiondetails/consume/${consumptionId}/${qtyConsumed}`);
};

export {
    getConsumptionState,
    getIssuingRequestOnline,
    getIssuingRequestOffline,
    issuePalletByIssuingRequest,
    deleteConsumption,
    consumeConsumption
};
